import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'

import Action from './Action'
import VocabularyHeaderSkeleton from './VocabularyHeaderSkeleton'

const VocabularyHeader = ({ studyVocabularyLink }) => {
  return (
    <VocabularyHeaderSkeleton
      nameSection={t('Vocabulary')}
      actionsSection={<Action studyVocabularyLink={studyVocabularyLink} />}
    />
  )
}

VocabularyHeader.propTypes = {
  studyVocabularyLink: PropTypes.string.isRequired,
}

export default VocabularyHeader
